import { ToneDto, ToneDtoImpl } from '../tonedto';
import { GroupDto } from './groupdto';

export interface ChildListTonesDto extends ToneDto
{
    getCreatedDate(): string;
    getCustomiseEndDate(): string;
    getCustomiseEndTime(): string;
    getCustomiseStartDate(): string;
    getCustomiseStartTime(): string;
    getEndDayMonthly(): string;
    getEndTime(): string;
    getEndTimeMonthly(): string;
    getEndTimeWeekly(): string;
    getIsShuffle(): string;
    getStartDayMonthly(): string;
    getStartTime(): string;
    getStartTimeMonthly(): string;
    getStartTimeWeekly(): string;
    getCallerStatus(): string;
    getWeeklyDays(): string;
    getYearlyEndDay(): string;
    getYearlyEndMonth(): string;
    getYearlyEndTime(): string;
    getYearlyStartDay(): string;
    getYearlyStartMonth(): string;
    getYearlyStartTime(): string;
    getServiceName(): string;
    getMsisdnB(): string;
    getIsStatusRBT(): boolean;
    getGroupDto(): GroupDto;
    getTimeTypeList():string[];
}

export class ChildListTonesDtoImpl extends ToneDtoImpl implements ChildListTonesDto
{
    private isStatusRBT: boolean = false;
    private createdDate: string;
    private customiseEndDate: string;
    private customiseEndTime: string;
    private customiseStartDate: string;
    private customiseStartTime: string;
    private endDayMonthly: string;
    private endTime: string;
    private endTimeMonthly: string;
    private endTimeWeekly: string;
    private isShuffle: string;
    private startDayMonthly: string;
    private startTime: string;
    private startTimeMonthly: string;
    private startTimeWeekly: string;
    private callerStatus: string;
    private weeklyDays: string;
    private yearlyEndDay: string;
    private yearlyEndMonth: string;
    private yearlyEndTime: string;
    private yearlyStartDay: string;
    private yearlyStartMonth: string;
    private yearlyStartTime: string;
    private serviceName: string;
    private groupDto: GroupDto;
    private msisdnB: string;
    private timeTypeList:string[];

    getIsStatusRBT(): boolean {
       return this.isStatusRBT;
    }
    setIsStatusRBT(isStatusRBT: boolean)
    {
        this.isStatusRBT = isStatusRBT;
    }

    setCreatedDate(createdDate: string)
    {
        this.createdDate = createdDate;
    }
    getCreatedDate(): string
    {
        return this.createdDate;
    }

    setCustomiseEndDate(customiseEndDate: string)
    {
        this.customiseEndDate = customiseEndDate;
    }
    getCustomiseEndDate(): string
    {
        return this.customiseEndDate;
    }

    setCustomiseEndTime(customiseEndTime: string)
    {
        this.customiseEndTime = customiseEndTime;
    }
    getCustomiseEndTime(): string
    {
        return this.customiseEndTime;
    }

    setCustomiseStartDate(customiseStartDate: string)
    {
        this.customiseStartDate = customiseStartDate;
    }
    getCustomiseStartDate(): string
    {
        return this.customiseStartDate;
    }

    setCustomiseStartTime(customiseStartTime: string)
    {
        this.customiseStartTime = customiseStartTime;
    }
    getCustomiseStartTime(): string
    {
        return this.customiseStartTime;
    }

    setEndDayMonthly(endDayMonthly: string)
    {
        this.endDayMonthly = endDayMonthly;
    }
    getEndDayMonthly(): string
    {
        return this.endDayMonthly;
    }

    setEndTime(endTime: string)
    {
        this.endTime = endTime;
    }
    getEndTime(): string
    {
        return this.endTime;
    }

    setEndTimeMonthly(endTimeMonthly: string)
    {
        this.endTimeMonthly = endTimeMonthly;
    }
    getEndTimeMonthly(): string
    {
        return this.endTimeMonthly;
    }

    setEndTimeWeekly(endTimeWeekly: string)
    {
        this.endTimeWeekly = endTimeWeekly;
    }
    getEndTimeWeekly(): string
    {
        return this.endTimeWeekly;
    }

    setIsShuffle(isShuffle: string)
    {
        this.isShuffle = isShuffle;
    }
    getIsShuffle(): string
    {
        return this.isShuffle;
    }

    setStartDayMonthly(startDayMonthly: string)
    {
        this.startDayMonthly = startDayMonthly;
    }
    getStartDayMonthly(): string
    {
        return this.startDayMonthly;
    }

    setStartTime(startTime: string)
    {
        this.startTime = startTime;
    }
    getStartTime(): string
    {
        return this.startTime;
    }

    setStartTimeMonthly(startTimeMonthly: string)
    {
        this.startTimeMonthly = startTimeMonthly;
    }
    getStartTimeMonthly(): string
    {
        return this.startTimeMonthly;
    }

    setStartTimeWeekly(startTimeWeekly: string)
    {
        this.startTimeWeekly = startTimeWeekly;
    }
    getStartTimeWeekly(): string
    {
        return this.startTimeWeekly;
    }

    setCallerStatus(callerstatus: string)
    {
        this.callerStatus = callerstatus;
    }
    getCallerStatus(): string
    {
        return this.callerStatus;
    }

    setWeeklyDays(weeklyDays: string)
    {
        this.weeklyDays = weeklyDays;
    }
    getWeeklyDays(): string
    {
        return this.weeklyDays;
    }

    setYearlyEndDay(yearlyEndDay: string)
    {
        this.yearlyEndDay = yearlyEndDay;
    }
    getYearlyEndDay(): string
    {
        return this.yearlyEndDay;
    }

    setYearlyEndMonth(yearlyEndMonth: string)
    {
        this.yearlyEndMonth = yearlyEndMonth;
    }
    getYearlyEndMonth(): string
    {
        return this.yearlyEndMonth;
    }

    setYearlyEndTime(yearlyEndTime: string)
    {
        this.yearlyEndTime = yearlyEndTime;
    }
    getYearlyEndTime(): string
    {
        return this.yearlyEndTime;
    }

    setYearlyStartDay(yearlyStartDay: string)
    {
        this.yearlyStartDay = yearlyStartDay;
    }
    getYearlyStartDay(): string
    {
        return this.yearlyStartDay;
    }

    setYearlyStartMonth(yearlyStartMonth: string)
    {
        this.yearlyStartMonth = yearlyStartMonth;
    }
    getYearlyStartMonth(): string
    {
        return this.yearlyStartMonth;
    }

    setYearlyStartTime(yearlyStartTime: string)
    {
        this.yearlyStartTime = yearlyStartTime;
    }
    getYearlyStartTime(): string
    {
        return this.yearlyStartTime;
    }

    setServiceName(serviceName: string)
    {
        this.serviceName = serviceName;
    }
    getServiceName(): string
    {
        return this.serviceName;
    }

    setGroupDto(groupDto: GroupDto)
    {
        this.groupDto = groupDto;
    }
    getGroupDto(): GroupDto
    {
        return this.groupDto;
    }

    setMsisdnB(msisdnB: string)
    {
        this.msisdnB = msisdnB;
    }
    getMsisdnB(): string
    {
        return this.msisdnB;
    }

    setTimeTypeList(timeTypeList:string[])
    {
        this.timeTypeList = timeTypeList;
    }
    getTimeTypeList():string[]
    {
        return this.timeTypeList;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/listtones/childlisttonesdto.ts